export const rankings = [
  {
    teams: [
      {
        position: 1,
        team: {
          teamId: 'POR',
          name: 'Portugal',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/POR_flag.png',
        },
        stats: {
          PTS: { value: 9, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 3, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 8, description: 'Goals scored' },
          GC: { value: 0, description: 'Goals conceded' },
          GD: { value: 8, description: 'Goal difference' },
        },
      },
      {
        position: 2,
        team: {
          teamId: 'BRA',
          name: 'Brasil',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/BRA_flag.png',
        },
        stats: {
          PTS: { value: 9, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 3, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 8, description: 'Goals scored' },
          GC: { value: 0, description: 'Goals conceded' },
          GD: { value: 8, description: 'Goal difference' },
        },
      },
      {
        position: 3,
        team: {
          teamId: 'ARG',
          name: 'Argentina',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/ARG_flag.png',
        },
        stats: {
          PTS: { value: 9, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 3, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 8, description: 'Goals scored' },
          GC: { value: 0, description: 'Goals conceded' },
          GD: { value: 8, description: 'Goal difference' },
        },
      },
      {
        position: 4,
        team: {
          teamId: 'FRA',
          name: 'Francia',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/FRA_flag.png',
        },
        stats: {
          PTS: { value: 7, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 8, description: 'Goals scored' },
          GC: { value: 0, description: 'Goals conceded' },
          GD: { value: 8, description: 'Goal difference' },
        },
      },
      {
        position: 5,
        team: {
          teamId: 'ESP',
          name: 'España',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/ESP_flag.png',
        },
        stats: {
          PTS: { value: 7, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 8, description: 'Goals scored' },
          GC: { value: 0, description: 'Goals conceded' },
          GD: { value: 8, description: 'Goal difference' },
        },
      },
      {
        position: 6,
        team: {
          teamId: 'ENG',
          name: 'Inglaterra',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/ENG_flag.png',
        },
        stats: {
          PTS: { value: 7, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 7, description: 'Goals scored' },
          GC: { value: 0, description: 'Goals conceded' },
          GD: { value: 7, description: 'Goal difference' },
        },
      },
      {
        position: 7,
        team: {
          teamId: 'GER',
          name: 'Alemania',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/GER_flag.png',
        },
        stats: {
          PTS: { value: 7, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 7, description: 'Goals scored' },
          GC: { value: 1, description: 'Goals conceded' },
          GD: { value: 6, description: 'Goal difference' },
        },
      },
      {
        position: 8,
        team: {
          teamId: 'NED',
          name: 'Países Bajos',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/NED_flag.png',
        },
        stats: {
          PTS: { value: 7, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 7, description: 'Goals scored' },
          GC: { value: 1, description: 'Goals conceded' },
          GD: { value: 6, description: 'Goal difference' },
        },
      },
      {
        position: 9,
        team: {
          teamId: 'BEL',
          name: 'Bélgica',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/BEL_flag.png',
        },
        stats: {
          PTS: { value: 7, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 7, description: 'Goals scored' },
          GC: { value: 1, description: 'Goals conceded' },
          GD: { value: 6, description: 'Goal difference' },
        },
      },
      {
        position: 10,
        team: {
          teamId: 'URU',
          name: 'Uruguay',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/URU_flag.png',
        },
        stats: {
          PTS: { value: 6, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 7, description: 'Goals scored' },
          GC: { value: 1, description: 'Goals conceded' },
          GD: { value: 6, description: 'Goal difference' },
        },
      },
      {
        position: 11,
        team: {
          teamId: 'CRO',
          name: 'Croacia',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CRO_flag.png',
        },
        stats: {
          PTS: { value: 6, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 7, description: 'Goals scored' },
          GC: { value: 1, description: 'Goals conceded' },
          GD: { value: 6, description: 'Goal difference' },
        },
      },
      {
        position: 12,
        team: {
          teamId: 'COL',
          name: 'Colombia',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/COL_flag.png',
        },
        stats: {
          PTS: { value: 6, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 6, description: 'Goals scored' },
          GC: { value: 1, description: 'Goals conceded' },
          GD: { value: 5, description: 'Goal difference' },
        },
      },
      {
        position: 13,
        team: {
          teamId: 'SEN',
          name: 'Senegal',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/SEN_flag.png',
        },
        stats: {
          PTS: { value: 6, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 6, description: 'Goals scored' },
          GC: { value: 1, description: 'Goals conceded' },
          GD: { value: 5, description: 'Goal difference' },
        },
      },
      {
        position: 14,
        team: {
          teamId: 'MEX',
          name: 'México',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/MEX_flag.png',
        },
        stats: {
          PTS: { value: 6, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 6, description: 'Goals scored' },
          GC: { value: 2, description: 'Goals conceded' },
          GD: { value: 4, description: 'Goal difference' },
        },
      },
      {
        position: 15,
        team: {
          teamId: 'USA',
          name: 'Estados Unidos',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/USA_flag.png',
        },
        stats: {
          PTS: { value: 6, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 2, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 6, description: 'Goals scored' },
          GC: { value: 2, description: 'Goals conceded' },
          GD: { value: 4, description: 'Goal difference' },
        },
      },
      {
        position: 16,
        team: {
          teamId: 'MAR',
          name: 'Marruecos',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/MAR_flag.png',
        },
        stats: {
          PTS: { value: 5, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 6, description: 'Goals scored' },
          GC: { value: 2, description: 'Goals conceded' },
          GD: { value: 4, description: 'Goal difference' },
        },
      },
      {
        position: 17,
        team: {
          teamId: 'JPN',
          name: 'Japón',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/JPN_flag.png',
        },
        stats: {
          PTS: { value: 5, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 6, description: 'Goals scored' },
          GC: { value: 2, description: 'Goals conceded' },
          GD: { value: 4, description: 'Goal difference' },
        },
      },
      {
        position: 18,
        team: {
          teamId: 'SUI',
          name: 'Suiza',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/SUI_flag.png',
        },
        stats: {
          PTS: { value: 5, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 5, description: 'Goals scored' },
          GC: { value: 2, description: 'Goals conceded' },
          GD: { value: 3, description: 'Goal difference' },
        },
      },
      {
        position: 19,
        team: {
          teamId: 'CIV',
          name: 'Costa de Marfil',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CIV_flag.png',
        },
        stats: {
          PTS: { value: 5, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 5, description: 'Goals scored' },
          GC: { value: 2, description: 'Goals conceded' },
          GD: { value: 3, description: 'Goal difference' },
        },
      },
      {
        position: 20,
        team: {
          teamId: 'CAN',
          name: 'Canadá',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CAN_flag.png',
        },
        stats: {
          PTS: { value: 5, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 0, description: 'Losses' },
          GF: { value: 5, description: 'Goals scored' },
          GC: { value: 2, description: 'Goals conceded' },
          GD: { value: 3, description: 'Goal difference' },
        },
      },
      {
        position: 21,
        team: {
          teamId: 'KOR',
          name: 'Corea del Sur',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/KOR_flag.png',
        },
        stats: {
          PTS: { value: 4, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 5, description: 'Goals scored' },
          GC: { value: 3, description: 'Goals conceded' },
          GD: { value: 2, description: 'Goal difference' },
        },
      },
      {
        position: 22,
        team: {
          teamId: 'PAR',
          name: 'Paraguay',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/PAR_flag.png',
        },
        stats: {
          PTS: { value: 4, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 5, description: 'Goals scored' },
          GC: { value: 3, description: 'Goals conceded' },
          GD: { value: 2, description: 'Goal difference' },
        },
      },
      {
        position: 23,
        team: {
          teamId: 'IRN',
          name: 'Irán',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/IRN_flag.png',
        },
        stats: {
          PTS: { value: 4, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 5, description: 'Goals scored' },
          GC: { value: 3, description: 'Goals conceded' },
          GD: { value: 2, description: 'Goal difference' },
        },
      },
      {
        position: 24,
        team: {
          teamId: 'QAT',
          name: 'Qatar',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/QAT_flag.png',
        },
        stats: {
          PTS: { value: 4, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 4, description: 'Goals scored' },
          GC: { value: 3, description: 'Goals conceded' },
          GD: { value: 1, description: 'Goal difference' },
        },
      },
      {
        position: 25,
        team: {
          teamId: 'ECU',
          name: 'Ecuador',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/ECU_flag.png',
        },
        stats: {
          PTS: { value: 4, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 4, description: 'Goals scored' },
          GC: { value: 3, description: 'Goals conceded' },
          GD: { value: 1, description: 'Goal difference' },
        },
      },
      {
        position: 26,
        team: {
          teamId: 'NOR',
          name: 'Noruega',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/NOR_flag.png',
        },
        stats: {
          PTS: { value: 4, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 4, description: 'Goals scored' },
          GC: { value: 3, description: 'Goals conceded' },
          GD: { value: 1, description: 'Goal difference' },
        },
      },
      {
        position: 27,
        team: {
          teamId: 'GHA',
          name: 'Ghana',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/GHA_flag.png',
        },
        stats: {
          PTS: { value: 3, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 4, description: 'Goals scored' },
          GC: { value: 3, description: 'Goals conceded' },
          GD: { value: 1, description: 'Goal difference' },
        },
      },
      {
        position: 28,
        team: {
          teamId: 'TUR',
          name: 'Turquía',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/TUR_flag.png',
        },
        stats: {
          PTS: { value: 3, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 4, description: 'Goals scored' },
          GC: { value: 4, description: 'Goals conceded' },
          GD: { value: 0, description: 'Goal difference' },
        },
      },
      {
        position: 29,
        team: {
          teamId: 'DZA',
          name: 'Argelia',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/DZA_flag.png',
        },
        stats: {
          PTS: { value: 3, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 4, description: 'Goals scored' },
          GC: { value: 4, description: 'Goals conceded' },
          GD: { value: 0, description: 'Goal difference' },
        },
      },
      {
        position: 30,
        team: {
          teamId: 'AUT',
          name: 'Austria',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/AUT_flag.png',
        },
        stats: {
          PTS: { value: 3, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 3, description: 'Goals scored' },
          GC: { value: 4, description: 'Goals conceded' },
          GD: { value: -1, description: 'Goal difference' },
        },
      },
      {
        position: 31,
        team: {
          teamId: 'UZB',
          name: 'Uzbekistán',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/UZB_flag.png',
        },
        stats: {
          PTS: { value: 3, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 1, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 3, description: 'Goals scored' },
          GC: { value: 4, description: 'Goals conceded' },
          GD: { value: -1, description: 'Goal difference' },
        },
      },
      {
        position: 32,
        team: {
          teamId: 'COD',
          name: 'RD del Congo',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/COD_flag.png',
        },
        stats: {
          PTS: { value: 2, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 3, description: 'Goals scored' },
          GC: { value: 4, description: 'Goals conceded' },
          GD: { value: -1, description: 'Goal difference' },
        },
      },
      {
        position: 33,
        team: {
          teamId: 'IRQ',
          name: 'Irak',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/IRQ_flag.png',
        },
        stats: {
          PTS: { value: 2, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 3, description: 'Goals scored' },
          GC: { value: 4, description: 'Goals conceded' },
          GD: { value: -1, description: 'Goal difference' },
        },
      },
      {
        position: 34,
        team: {
          teamId: 'SWE',
          name: 'Suecia',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/SWE_flag.png',
        },
        stats: {
          PTS: { value: 2, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 3, description: 'Goals scored' },
          GC: { value: 4, description: 'Goals conceded' },
          GD: { value: -1, description: 'Goal difference' },
        },
      },
      {
        position: 35,
        team: {
          teamId: 'TUN',
          name: 'Túnez',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/TUN_flag.png',
        },
        stats: {
          PTS: { value: 2, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 3, description: 'Goals scored' },
          GC: { value: 5, description: 'Goals conceded' },
          GD: { value: -2, description: 'Goal difference' },
        },
      },
      {
        position: 36,
        team: {
          teamId: 'AUS',
          name: 'Australia',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/AUS_flag.png',
        },
        stats: {
          PTS: { value: 2, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 2, description: 'Draws' },
          P: { value: 1, description: 'Losses' },
          GF: { value: 2, description: 'Goals scored' },
          GC: { value: 5, description: 'Goals conceded' },
          GD: { value: -3, description: 'Goal difference' },
        },
      },
      {
        position: 37,
        team: {
          teamId: 'PAN',
          name: 'Panamá',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/PAN_flag.png',
        },
        stats: {
          PTS: { value: 1, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 2, description: 'Goals scored' },
          GC: { value: 5, description: 'Goals conceded' },
          GD: { value: -3, description: 'Goal difference' },
        },
      },
      {
        position: 38,
        team: {
          teamId: 'JOR',
          name: 'Jordania',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/JOR_flag.png',
        },
        stats: {
          PTS: { value: 1, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 2, description: 'Goals scored' },
          GC: { value: 5, description: 'Goals conceded' },
          GD: { value: -3, description: 'Goal difference' },
        },
      },
      {
        position: 39,
        team: {
          teamId: 'EGY',
          name: 'Egipto',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/EGY_flag.png',
        },
        stats: {
          PTS: { value: 1, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 2, description: 'Goals scored' },
          GC: { value: 5, description: 'Goals conceded' },
          GD: { value: -3, description: 'Goal difference' },
        },
      },
      {
        position: 40,
        team: {
          teamId: 'CZE',
          name: 'Chequia',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CZE_flag.png',
        },
        stats: {
          PTS: { value: 1, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 2, description: 'Goals scored' },
          GC: { value: 5, description: 'Goals conceded' },
          GD: { value: -3, description: 'Goal difference' },
        },
      },
      {
        position: 41,
        team: {
          teamId: 'BIH',
          name: 'Bosnia y Herzegovina',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/BIH_flag.png',
        },
        stats: {
          PTS: { value: 1, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 1, description: 'Draws' },
          P: { value: 2, description: 'Losses' },
          GF: { value: 2, description: 'Goals scored' },
          GC: { value: 5, description: 'Goals conceded' },
          GD: { value: -3, description: 'Goal difference' },
        },
      },
      {
        position: 42,
        team: {
          teamId: 'SCO',
          name: 'Escocia',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/SCO_flag.png',
        },
        stats: {
          PTS: { value: 0, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 3, description: 'Losses' },
          GF: { value: 1, description: 'Goals scored' },
          GC: { value: 6, description: 'Goals conceded' },
          GD: { value: -5, description: 'Goal difference' },
        },
      },
      {
        position: 43,
        team: {
          teamId: 'NZL',
          name: 'Nueva Zelanda',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/NZL_flag.png',
        },
        stats: {
          PTS: { value: 0, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 3, description: 'Losses' },
          GF: { value: 1, description: 'Goals scored' },
          GC: { value: 6, description: 'Goals conceded' },
          GD: { value: -5, description: 'Goal difference' },
        },
      },
      {
        position: 44,
        team: {
          teamId: 'SAU',
          name: 'Arabia Saudita',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/SAU_flag.png',
        },
        stats: {
          PTS: { value: 0, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 3, description: 'Losses' },
          GF: { value: 1, description: 'Goals scored' },
          GC: { value: 6, description: 'Goals conceded' },
          GD: { value: -5, description: 'Goal difference' },
        },
      },
      {
        position: 45,
        team: {
          teamId: 'CPV',
          name: 'Cabo Verde',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CPV_flag.png',
        },
        stats: {
          PTS: { value: 0, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 3, description: 'Losses' },
          GF: { value: 1, description: 'Goals scored' },
          GC: { value: 6, description: 'Goals conceded' },
          GD: { value: -5, description: 'Goal difference' },
        },
      },
      {
        position: 46,
        team: {
          teamId: 'CUW',
          name: 'Curazao',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/CUW_flag.png',
        },
        stats: {
          PTS: { value: 0, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 3, description: 'Losses' },
          GF: { value: 1, description: 'Goals scored' },
          GC: { value: 6, description: 'Goals conceded' },
          GD: { value: -5, description: 'Goal difference' },
        },
      },
      {
        position: 47,
        team: {
          teamId: 'HTI',
          name: 'Haití',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/HTI_flag.png',
        },
        stats: {
          PTS: { value: 0, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 3, description: 'Losses' },
          GF: { value: 1, description: 'Goals scored' },
          GC: { value: 6, description: 'Goals conceded' },
          GD: { value: -5, description: 'Goal difference' },
        },
      },
      {
        position: 48,
        team: {
          teamId: 'ZAF',
          name: 'Sudáfrica',
          flagUrl: 'https://images.clarovideo.com/esg-images/GNA5MGHG2ZVX2RD/flags/ZAF_flag.png',
        },
        stats: {
          PTS: { value: 0, description: 'Total points' },
          PTD: { value: 3, description: 'Matches played' },
          G: { value: 0, description: 'Wins' },
          E: { value: 0, description: 'Draws' },
          P: { value: 3, description: 'Losses' },
          GF: { value: 1, description: 'Goals scored' },
          GC: { value: 6, description: 'Goals conceded' },
          GD: { value: -5, description: 'Goal difference' },
        },
      },
    ],
  },
];
